interface WrapperSectionProps {
  className: string;
  children?: React.ReactNode;
}

export const WrapperSection = ({
  className,
  children,
}: WrapperSectionProps) => {
  return <div className={className}>{children}</div>;
};
